import React from 'react';
import Time from 'react-time';
import AppActions from '../../actions/app-actions';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

//Icons
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import BuildIcon from '@material-ui/icons/Build';
import BugReportIcon from '@material-ui/icons/BugReport';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';

import { isEmpty, preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';

import ExpandJsonView from '../configurations/expand-json-view';
import { yellow } from '@material-ui/core/colors';
import { DialogContentText } from '@material-ui/core';
//NOTE: Add new actions to the end, do not change the order.
//      Index is used for maintaining mask (changed actions) and so if order is changed
//      older actions might show wrong state.
const enablerActions = [
  {
    name: 'logExport',
    label: 'Log Export',
    isEnabled: false
  },
  {
    name: 'cameraAccess',
    label: 'Camera Webpage Access',
    isEnabled: true
  },
  {
    name: 'hardenFirewall',
    label: 'Harden Firewall ',
    isEnabled: true
  },
  {
    name: 'sshAccess',
    label: 'SSH Access',
    isEnabled: true
  },
  {
    name: 'debug',
    label: 'Debug',
    isEnabled: false
  }
];

const alarmDialogHeaders = [
  /*
  {
    name: 'timestamp',
    label: 'Timestamp',
    render: alarm => (alarm.timestamp ? alarm.timestamp : '-')
  },
  */

  {
    name: 'alarm',
    label: 'Alarm',
    render: alarm => (alarm ? alarm.alarm : '-')
  },
  {
    name: 'module',
    label: 'Module',
    render: alarm => (alarm ? alarm.module : '-')
  },
  {
    name: 'status',
    label: 'Status',
    render: alarm => (alarm ? alarm.status : '-')
  },
  {
    name: 'message',
    label: 'Message',
    render: alarm => (alarm ? alarm.message : '-')
  },
  {
    name: 'updated_ts',
    label: 'Updated Time',
    render: alarm => (alarm ? alarm.updated_ts ?  alarm.updated_ts: '-' : '-')
  }
];
//NOTE: Add new actions to the end, do not change the order.
//      Index is used for maintaining mask (changed actions) and so if order is changed
//      older actions might show wrong state.
const instantActions = [
  {
    name: 'reboot',
    label: 'Reboot',
    text: actions => (actions.reboot ? 'Initiated reboot' : 'Initiate reboot'),
    icon: actions => {
      let actIcon = (actions.reboot ? <RotateLeftIcon className="green" /> : <PowerSettingsNewIcon className="green" />);
      return actIcon;
    }
  },
  {
    name: 'cleanup',
    label: 'Device Cleanup',
    text: actions => (actions.cleanup ? 'Initiated cleanup' : 'Initiate cleanup'),
    icon: actions => {
      let actIcon = (actions.cleanup ? <RotateLeftIcon className="green" /> : <DeleteOutlineIcon className="green" />);
      return actIcon;
    }
  },
  {
    name: 'reset',
    label: 'Factory Reset',
    text: actions => (actions.reset ? 'Initiated reset' : 'Initiate reset'),
    icon: actions => {
      let actIcon = (actions.reset ? <RotateLeftIcon className="green" /> : <RestorePageIcon className="green" />);
      return actIcon;
    }
  },
  {
    name: 'enroll',
    label: 'Enroll',
    text: (actions) => (actions.enroll ? 'Initiated basic install' : 'Initiate basic install'),
    icon: (actions) => {
      let actIcon = (actions.enroll ? <RotateLeftIcon className="green" /> : <BuildIcon className="green" />);
      return actIcon;
    }
  },
  {
    name: 'logExport',
    label: 'Instant Logs Export',
    text: (actions) => (actions.logExport ? 'Initiated log export': 'Initiate log export'),
    icon: (actions) => {
      let actIcon = (actions.logExport ? <RotateLeftIcon className="green" /> : <BugReportIcon className="green" />);
      return actIcon;      
    }
  }
]
const buttonStyle = { textTransform: 'none', textAlign: 'left' };

/* actionInfo - Sample Payload from DB //

  device_id: "5d9182259863150001bccbc5"
  actions: {
    status: 0,
    details: "{"reboot":false,"cleanup":true,"reset":true,"cameraUpdate":false}"
  }
  alarms: "IN1,WN1,EN1"
  enablers: {
    status: 0,
    details: "{"logExport":true,"cameraAccess":true,"hardenFirewall":true,"sshAccess":true,"debug":false}"
  }
  env_vars: {
    status: 0,
    details: "{}"
  }
  id: "5d918770a84ec20001848775"
  appstatus: null
  created_ts: "2019-09-30T04:41:20.532Z"
  updated_ts: "2019-10-04T04:26:00.733Z"
*/

export default class ExpandedAction extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      currentUserRole: getUserRoleFromJWT(),
      actions: this.parseActionInfo('actions', this.props.actionInfo),
      enablers: this.parseActionInfo('enablers', this.props.actionInfo),
      env_vars: this.parseActionInfo('env_vars', this.props.actionInfo),
      alarms: this.parseActionInfo('alarms', this.props.actionInfo),
      alarmStat:[],
      selectedAlarmType:'All',
      actionDlg: {
        open: false
      }
    }
    this.handleCustomEnv = this.handleCustomEnv.bind(this);
    // Added for basic install support
    const localConfInfo = props.basicInstall || {};
    const config_details = localConfInfo.config_details || '{}';
    const confDetailsObj = JSON.parse(config_details);
    const { basic_installation={} } = confDetailsObj;
    const { install_progress_step=-1 } = basic_installation;
    const enrollAction = instantActions.find(action => action.name === 'enroll');
    if (enrollAction) {
      enrollAction.isDisabled = install_progress_step !== 0;
    }
  }
  static prevProps = null;

  static hasPropsChanged(nextProps) {
    //isEmpty(nextProps.device.actionInfo) will be true if there are no entries in DB for this device,
    //in such a case, default values shall be shown.
    if(ExpandedAction.prevProps === null || isEmpty(nextProps.actionInfo)) {
      ExpandedAction.prevProps = nextProps;
      return true;
    }

    let prev = ExpandedAction.prevProps.actionInfo;
    let curr = nextProps.actionInfo;
    //console.log('prevProps ' + JSON.stringify(prev));
    //console.log('currProps ' + JSON.stringify(curr));
    if (!curr.actions || !prev.actions ||
      curr.actions.status !== prev.actions.status ||
      curr.actions.details !== prev.actions.details ||
      curr.enablers.status !== prev.enablers.status ||
      curr.enablers.details !== prev.enablers.details ||
      curr.env_vars.status !== prev.env_vars.status ||
      curr.env_vars.details !== prev.env_vars.details ||
      curr.alarms !== prev.alarms) {
      ExpandedAction.prevProps = nextProps;
      return true;
    }

    return false;
  }

  static parseInfo(type, actionInfo) {
    let container = {
      status: 0,
      details: {}
    };
    let alarms = [];

    if (!isEmpty(actionInfo) && !isEmpty(actionInfo[type])) {
      if(type !== 'alarms') {
        container.status = actionInfo[type].status;
        container.details = !isEmpty(actionInfo[type].details) ? JSON.parse(actionInfo[type].details): {};
      } else {
        actionInfo[type].map(alarm => {
          alarms.push(alarm);
        });


      }
    } else {
      /* Default case, when there is no entry in DB for the device */
      /* Ideally there shall be an entry in db for each device with the default values */
      if (type === 'actions') {
        instantActions.map(action => {
          container.details[action.name] = false;
        })
      } else if (type === 'enablers') {
        enablerActions.map(enabler => {
          container.details[enabler.name] = enabler.isEnabled;
        });
      }
    }
    return (type === 'alarms') ? alarms : container;
  }

  static getDerivedStateFromProps(nextProps) {
    var hasChanged = ExpandedAction.hasPropsChanged(nextProps);
    if(hasChanged) {
      let actions   = ExpandedAction.parseInfo('actions', nextProps.actionInfo);
      let enablers  = ExpandedAction.parseInfo('enablers', nextProps.actionInfo);
      let env_vars  = ExpandedAction.parseInfo('env_vars', nextProps.actionInfo);
      let alarms    = ExpandedAction.parseInfo('alarms', nextProps.actionInfo);

      let alarmStat = [0, 0, 0];

      alarms.forEach((alarm) =>{
        alarmStat[alarm.status] += 1;
      })

      return {
        actions: actions,
        enablers: enablers,
        env_vars: env_vars,
        alarms: alarms,
        alarmStat:alarmStat
      }
    }
    return null;
  }

  componentDidMount() {}

  parseActionInfo(type, actionInfo) {
    let container = {
      status: 0,
      details: {}
    };
    let alarms = [];
    if (!isEmpty(actionInfo) && !isEmpty(actionInfo[type])) {
      if(type !== 'alarms') {
        container.status = actionInfo[type].status;
        container.details = !isEmpty(actionInfo[type].details) ? JSON.parse(actionInfo[type].details): {};
      } else {
        actionInfo[type].map(alarm => {
          alarms.push(alarm);
        });
      }
    } else {
      /* Default case, when there is no entry in DB for the device */
      /* Ideally there shall be an entry in db for each device with the default values */
      if (type === 'actions') {
        instantActions.map(action => {
          container.details[action.name] = false;
        })
      } else if (type === 'enablers') {
        enablerActions.map(enabler => {
          container.details[enabler.name] = enabler.isEnabled;
        });
      }
    }
    return (type === 'alarms') ? alarms : container;
  }

  dialogToggle(ref) {
    var state = {};
    state[ref] = !this.state[ref];
    this.setState(state);
    //this.props.pause();
  }

  getActionInfo(device) {
    AppActions.getActionByDeviceId(device.id).then(data => {
      const actions = this.parseActionInfo('actions', data);
      const enablers = this.parseActionInfo('enablers', data);
      const env_vars = this.parseActionInfo('env_vars', data);
      const alarms = this.parseActionInfo('alarms', data);
      const alarmStat = [0, 0, 0];

      alarms.forEach((alarm) =>{
        alarmStat[alarm.status] += 1;
      })
      this.setState({alarms, alarmStat,actions, enablers, env_vars, actionDlg: { open: false }}, ()=>{
        this.props.updateActionInfo(data);
      });
    });
  }


  createActionInfo() {
    let actionInfo = {};
    let actions = {};
    actions.status = this.state.actions.status;
    actions.details = JSON.stringify(this.state.actions.details);
    let enablers = {};
    enablers.status = this.state.enablers.status;
    enablers.details = JSON.stringify(this.state.enablers.details);
    let env_vars = {};
    env_vars.status = this.state.env_vars.status;
    env_vars.details = JSON.stringify(this.state.env_vars.details);

    actionInfo.actions = actions;
    actionInfo.enablers = enablers;
    actionInfo.env_vars = env_vars;
    return actionInfo;
  }

  updateActionInfo(device, actionInfo) {
    var self = this;
    var callback = {
      success: function() {
        AppActions.setSnackbar(
          'Device Actions was updated successfully.'
        );
        self.getActionInfo(device);
      },
      error: function(err) {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(
          preformatWithRequestID(
            err.res,
            'There was an error updating Device Action. ' + errMsg
          )
        );
      }
    };
    if (isEmpty(device.actionInfo) || device.actionInfo.id === '') {
      AppActions.createActionByDeviceId(device.id, JSON.stringify(actionInfo), callback);
    } else {
      //console.log('updateActionInfo - state: ' + JSON.stringify(actionInfo));
      AppActions.updateActionByDeviceId(device.id, JSON.stringify(actionInfo), callback);
    }
  }

  /* TODO: Get a better way to do this, instead of setState and update db for every change??? */
  handleActions = name => {
    const self = this;
    const { actions } = self.state;
    const newActions = JSON.parse(JSON.stringify(actions));
    const mask = instantActions.findIndex(action => {
      return (action.name === name);
    });
    const handleOk = () => {
      newActions.status ^= (1 << mask);
      newActions.details[name] = !newActions.details[name];
      self.setState({actions: newActions}, () => {
        self.updateActionInfo(self.props.device, self.createActionInfo());
      });
    };
    const handleCancel = () => {
      self.setState({ actionDlg: { open: false }});
    };
    if (newActions.status & (1 << mask)) {
      AppActions.setSnackbar('Device Actions already initiated.');
      // this.setState({ actionDlg: {open: true, txt: name, handleOk, handleCancel }});
    } else {
      this.setState({ actionDlg: {open: true, txt: name, handleOk, handleCancel }});
    }
  }

  handleEnablers = name => () => {
    //console.log('handleEnablers - ' + name);
    const { enablers } = this.state;
    const newEnablers = JSON.parse(JSON.stringify(enablers));
    const mask = enablerActions.findIndex(enabler => {
      return (enabler.name === name);
    });
    newEnablers.status ^= (1 << mask);
    newEnablers.details[name] = !newEnablers.details[name];
    this.setState({enablers: newEnablers}, () => {
      this.updateActionInfo(this.props.device, this.createActionInfo());
    });
  }

  // Handle edited custom env from JSON viewer
  handleCustomEnv = (e) => {
    //console.log('handleCustomEnv : ', e.updated_src);
    const {env_vars} = this.state;
    let new_env_vars = JSON.parse(JSON.stringify(env_vars));
    new_env_vars.details = e.updated_src;
    new_env_vars.status = 0;
    this.setState({ env_vars:new_env_vars }, () => {
      //console.log(this.state.env_vars);
    });
  }

  handleCancel = () => {
    this.setState({showCustomEnv: false});
  }
  handleSubmit = () => {
    const {env_vars} = this.state;
    let new_env_vars = JSON.parse(JSON.stringify(env_vars));
    new_env_vars.status = 1;
    this.setState({env_vars:new_env_vars, showCustomEnv:false}, () => {
      this.updateActionInfo(this.props.device, this.createActionInfo());
    });
  }

  handleAlarms (index){
    this.setState({selectedAlarmType: index}, ()=>{
      this.dialogToggle('showAlarm')
    });

  }

  handleAlarmsDisplay (alarms) {

    var selectedAlarms = alarms.filter(alarm => alarm.status === this.state.selectedAlarmType || this.state.selectedAlarmType === 'All').map((alarm,index)=>{
      return (
        <TableRow key={index}>
          <TableCell style={{paddingTop: '4px'}}>{alarm.alarm}</TableCell>
          <TableCell style={{paddingTop: '4px'}} >{alarm.module}</TableCell>
          <TableCell style={ alarm.status === 2 ? {paddingTop: '4px', color: 'red'} : {paddingTop: '4px'}}>{alarm.status === 0 ? 'Info': alarm.status === 1 ? 'Warn': 'Error'}</TableCell>
          <TableCell style={{paddingTop: '4px'}}>{alarm.message}</TableCell>
          <TableCell style={{paddingTop: '4px'}}>{ alarm.updated_ts ? <Time value={alarm.updated_ts} format="YYYY-MM-DD HH:mm" /> : '-' }</TableCell>
        </TableRow>);
    });
    return selectedAlarms;
  }

  _actionDialog() {
    return (
      <Dialog
        open={this.state.actionDlg.open}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>{`Do you want to trigger the "${this.state.actionDlg.txt}" action`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' color='primary' onClick={this.state.actionDlg.handleOk}>Ok</Button>
          <Button variant='contained' onClick={this.state.actionDlg.handleCancel}>Cancel</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const self = this;
    const actions = self.state.actions;
    const enablers = self.state.enablers;
    const env_vars = self.state.env_vars;
    const alarms = self.state.alarms || [];
    const alarmStat = self.state.alarmStat || [];
    const actionHeader = (actions.status === 0) ? 'Actions' : 'Actions (Pending...)';
    const enablerHeader = (enablers.status === 0) ? 'Enablers' : 'Enablers (Pending...)';
    const envHeader = (env_vars.status === 0) ? 'Device Attributes' : 'Device Attributes (Pending...)';
    const customEnvDialogActions = (
      <div>
        <Button onClick={() => self.dialogToggle('showCustomEnv')} style={{ marginRight: '10px' }} color="secondary" variant="contained">
          Cancel
        </Button>
        <Button disabled={this.state.currentUserRole !== 'admin'} onClick={self.handleSubmit} color="secondary" variant="contained">
          Submit
        </Button>
      </div>
    );

    const alarmDialogActions = (
      <div>
        <Button onClick={() => self.dialogToggle('showAlarm')} style={{ marginRight: '10px' }} color="secondary" variant="contained">
          Close
        </Button>
      </div>
    );

    return (
      <div className="margin-bottom-small flexbox" style={{ flexDirection: 'row' }}>
        <List subheader={<ListSubheader>Alarms</ListSubheader>} className="list-horizontal-display" style={{ borderRight: '0.1em solid #d9d9d9', minWidth: '22%' }}>

          {alarmStat.map((astat,index) => (
            <ListItem
              button
              key={index}
              disabled={this.state.currentUserRole !== 'admin'}
              onClick={() => self.handleAlarms(index)}
              style={{width: '95%', marginBottom: '5px'}}
            >
              <ListItemIcon>
                {index === 0 ? <InfoOutlinedIcon className='green'/> : index === 1 ? <WarningOutlinedIcon style={{ color: yellow[500] }}  /> : <NotificationImportantOutlinedIcon className='red'/>}
              </ListItemIcon>
              <ListItemText primary={index == 0? 'Info          ' + '[' + astat + ']' : index == 1 ? 'Warn          ' + '[' +astat + ']': 'Error          ' + '[' +astat+ ']' } />

            </ListItem>
          )).reverse()}

          <Button style={{ width: '80%' }}
            onClick={() => {
              self.handleAlarms('All');
              AppActions.setSnackbar('');
            }}
          >
            <span className="inline-block">
              <Typography component="span" variant="subtitle1" style={buttonStyle}>
                View Alarms
              </Typography>
              <Typography variant="caption" display="block" className="muted" style={buttonStyle}>
                Click to view all alarms
              </Typography>
            </span>
          </Button>
        </List>
        <List subheader={<ListSubheader>{actionHeader}</ListSubheader>}
          className="list-horizontal-display"
          style={{ marginLeft: '2em', borderRight: '0.1em solid #d9d9d9', minWidth: '25%' }}
        >
          {instantActions.map(action => (
            <ListItem
              key={action.name}
              button
              disabled={this.state.currentUserRole !== 'admin' || action.isDisabled}
              onClick={() => self.handleActions(action.name)}
              style={{width: '95%'}}
            >
              <ListItemText primary={action.label} secondary={action.text(actions.details)}/>
              <ListItemIcon>
                {action.icon(actions.details)}
              </ListItemIcon>
            </ListItem>
          ))}
        </List>
        <List subheader={<ListSubheader>{enablerHeader}</ListSubheader>} className="list-horizontal-display" style={{ marginLeft: '2em', paddingRight: '2%', borderRight: '0.1em solid #d9d9d9', minWidth: '25%' }}>
          {enablerActions.map((enabler) => (
            <ListItem key={enabler.label} style={{marginBottom: '5px'}}>
              <ListItemText primary={enabler.label} style={{marginRight: '3em'}} />
              <ListItemSecondaryAction>
                <Switch
                  disabled={this.state.currentUserRole !== 'admin'}
                  onChange={self.handleEnablers(enabler.name).bind(this)}
                  checked={enablers.details[enabler.name]}
                  color="primary"
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
        <List subheader={<ListSubheader>{envHeader}</ListSubheader>} className="list-horizontal-display" style={{ marginLeft: '2em', minWidth: '22%' }}>
          <Button style={{ width: '100%' }}
            onClick={() => {
              self.dialogToggle('showCustomEnv');
              AppActions.setSnackbar('');
            }}
          >
            <span className="inline-block">
              <Typography component="span" variant="subtitle1" style={buttonStyle}>
                View/Edit Device Attributes
              </Typography>
              <Typography variant="caption" display="block" className="muted" style={{textTransform: 'none'}}>
                Click to view/edit device attributes
              </Typography>
            </span>
          </Button>
        </List>
        <Dialog
          open={this.state.showCustomEnv}
          maxWidth="lg"
          minWidth="md"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden'
          }}
        >
          <DialogTitle>View/Update Device Attributes</DialogTitle>
          <DialogContent>
            <ExpandJsonView
              config={env_vars.details || {}}
              name={null}
              enableClipboard={false}
              onAdd={this.state.currentUserRole !== 'admin' ? false : self.handleCustomEnv}
              onEdit={this.state.currentUserRole !== 'admin' ? false : self.handleCustomEnv}
              onDelete={this.state.currentUserRole !== 'admin' ? false : self.handleCustomEnv}
            />
          </DialogContent>
          <DialogActions>{customEnvDialogActions}</DialogActions>
        </Dialog>
        <Dialog
          open={self.state.showAlarm}
          fullWidth={true}
          maxWidth="md"
          style={{
            paddingTop: '0',
            fontSize: '13px',
            overflow: 'hidden',
          }}
        >

          <DialogContent>
            <div>
              <Table>
                <TableHead >
                  <TableRow>
                    {alarmDialogHeaders.map(colHeader => (
                      <TableCell  style={{paddingBottom: '10px', fontSize: '20px', fontWeight: 'bold'}} key={colHeader.name}>
                        {colHeader.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.handleAlarmsDisplay(alarms)}
                </TableBody>
              </Table>
            </div>
          </DialogContent>
          <DialogActions>{alarmDialogActions}</DialogActions>
        </Dialog>
        {this._actionDialog()}
      </div>
    );
  }
}
